import { useState } from "react";
import { Input, Picker } from "antd-mobile";
import { countryCodeOptions } from "constants/countryCodes";

export interface PhoneInputProps {
    value?: {
        countryCode: number;
        phoneNumber: string;
    };
    onChange?: (value: { countryCode: number; phoneNumber: string }) => void;
    placeholder?: string;
    size?: "small" | "medium" | "large";
    disabled?: boolean;
}

export const PhoneInput : React.FC<PhoneInputProps> = ({ 
    value, 
    onChange, 
    placeholder = "Phone Number", 
    size = "medium",
    disabled = false 
}) => {
    const [countryCode, setCountryCode] = useState<number>(value?.countryCode || 1);
    const [phoneNumber, setPhoneNumber] = useState<string>(value?.phoneNumber || "");
    const [pickerVisible, setPickerVisible] = useState(false);

    const handleCountryCodeChange = (selectedValue: any[]) => {
        const newCountryCode = selectedValue[0] as number;
        setCountryCode(newCountryCode);
        
        const newValue = {
            countryCode: newCountryCode,
            phoneNumber
        };
        
        onChange?.(newValue);
    };

    const handlePhoneNumberChange = (newPhoneNumber: string) => {
        setPhoneNumber(newPhoneNumber);
        
        const newValue = {
            countryCode,
            phoneNumber: newPhoneNumber
        };
        
        onChange?.(newValue);
    };

    const selectedCountryLabel = countryCodeOptions.find(option => option.value === countryCode)?.label || '+1';

    return (
        <div className="border rounded-lg flex items-center overflow-hidden bg-white">
            <div 
                className={`flex items-center justify-center px-2 py-2 bg-gray-50 border-r min-w-14 cursor-pointer h-full ${size === "small" ? "text-sm" : size === "large" ? "text-lg" : "text-md"}`}
                onClick={() => !disabled && setPickerVisible(true)}
            >
                <span className="text-md font-medium text-gray-500">
                    {selectedCountryLabel}
                </span>
            </div>
            
            <div className="flex-1 px-2">
                <Input
                    placeholder={placeholder}
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    disabled={disabled}
                />
            </div>

            <Picker
                columns={[countryCodeOptions]}
                visible={pickerVisible}
                onClose={() => setPickerVisible(false)}
                onConfirm={handleCountryCodeChange}
                value={[countryCode]}
                title="Select Country Code"
            />
        </div>
    );
};   
